/**
 * Comutatorul ecranului «Comandă recipiente DBA» (SP-04, T4).
 *
 * OPRIT implicit, si citit o singura data, aici: `VITE_*` se inline-uieste la
 * BUILD, deci valoarea nu se schimba la runtime.
 *
 * Cat timp e oprit, ruta nu se inregistreaza deloc (vezi `routes-provider`), deci
 * nici intrarea de meniu n-are unde sa duca: fara flag, zero comportament nou.
 *
 * ⚠️ Flagul asta are o pereche in backend — `RECIPIENTS_ENABLED`. Pornit singur,
 * da un ecran care nu poate functiona (rutele raspund 404), exact ca
 * `VITE_AUTENTIFICARE_COD` fata de `auth.otp.enabled`. Ordinea e: intai backendul.
 */
/* 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste textual
   `import.meta.env.VITE_...` la build. Un `(import.meta as {...}).env?.VITE_...`
   compileaza si ramane `undefined` in bundle, deci flagul e mereu oprit — s-a
   platit deja o data, la pasul de video. */
export const CERE_RECIPIENTE_ACTIV =
    String(import.meta.env.VITE_CERE_RECIPIENTE ?? '').toLowerCase() === 'true';
